import { useQuery } from '@tanstack/react-query';

import { fetchOCCarrierInfo } from '../../data-provider/select-options/carrier-info';

export const useGetOCCarrierInfo = (carrierKey: number | undefined) => {
  return useQuery({
    enabled: Boolean(carrierKey),
    queryFn: () => fetchOCCarrierInfo({ CarrierKey: Number(carrierKey) }),
    queryKey: ['claims-over-charge-carrier-info', carrierKey],
  });
};
